import RichText from 'components/UI/Richtext';
import { ReactElement } from 'react';
import { IComponentTextOnlyFields } from 'types/contentful';

export default function TextOnly({ text, openInNewTab }: IComponentTextOnlyFields): ReactElement {
  return (
    <RichText
      classNames={
        'prose prose-sm sm:prose lg:prose-lg max-w-none px-site-component ecp-my pb-10 md:pb-20 text-lg break-words text-only-richtext mx-auto ' +
        (openInNewTab ? 'openInNewTab' : 'doNotOpenInNewTab')
      }
      document={text}
    />
  );
}
